import React from 'react'

const Status:React.FC<{status: number}> = ({status}) => {
  const statusMap: { [key: number]: string } = {
    0: 'pendente',
    1: 'em andamento',
    2: 'concluído',
    3: 'cancelado',
  }
  const colorMap: { [key: number]: string } = {
    0: '#67C97E',
    1: '#FFC107',
    2: '#51A351',
    3: '#FE6765',
  }
  return (
    <div style={{
      backgroundColor: colorMap[status],
      color: '#424746',
      padding: '0.5rem',
      borderRadius: '0.5rem',
      marginBottom: '8px',
      textTransform: 'uppercase',
      fontSize: '12px',
      fontWeight: '600',
      width: 'fit-content',
    }}>{statusMap[status]}</div>
  )
}

export default Status
